module.exports = __webpack_public_path__ + "static/media/emojis_09.8504655f.svg";